import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import MusicSection from '../components/MusicSection';
import GallerySection from '../components/GallerySection';
import BookingSection from '../components/BookingSection';
import EventsSection from '../components/EventsSection';
import Footer from '../components/Footer';
import { artistInfo } from '../mock';

const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // JSON-LD Structured Data for SEO - MusicGroup
  const musicGroupData = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "name": "JLEE",
    "alternateName": "Jessie Lawrence",
    "description": "JLEE. Dubstep & electronic music. Kelowna, BC. Releases on Apple Music and SoundCloud.",
    "url": "https://jleemusic.ca",
    "sameAs": [
      artistInfo.soundcloudUrl,
      artistInfo.appleMusicUrl,
      `https://instagram.com/${artistInfo.instagram.replace('@', '')}`
    ],
    "areaServed": {
      "@type": "City",
      "name": "Kelowna",
      "containedIn": {
        "@type": "State",
        "name": "British Columbia",
        "containedIn": {
          "@type": "Country",
          "name": "Canada"
        }
      }
    },
    "genre": artistInfo.genres,
    "email": artistInfo.email
  };


  return (
    <>
      {/* MusicGroup Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(musicGroupData) }}
      />
      <div className="min-h-screen bg-black">
        <Navigation isScrolled={isScrolled} />
        <HeroSection />
        <EventsSection />
        <AboutSection />
        <MusicSection />
        <GallerySection />
        <BookingSection />
        <Footer />
      </div>
    </>
  );
};

export default HomePage;